<div class="spinner" [ngStyle]="stylesContent" id="spinner-control">
  <div class="spinner__wrapper">
    <div class="spinner__wrapper--box">
      <svg viewBox="0 0 50 50">
        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
      </svg>
    </div>
  </div>
</div>
